var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-simple-tab"},[_c('div',{staticClass:"ui-simple-tab__buttons"},_vm._l((_vm.buttons),function(btn){return _c('div',{key:btn.id,staticClass:"\n        ui-simple-tab__tab\n        pb-4\n        pb-8--m\n      ",class:[
        _vm.textClasses,
        {
          'ui-simple-tab__tab--active': btn.id === _vm.selectedButton,
          'txt--color-03': btn.id !== _vm.selectedButton && _vm.disabled,
          'ui-simple-tab__tab--active-red':
            btn.activeColor && btn.id === _vm.selectedButton,
        } ],on:{"click":function($event){!_vm.disabled && _vm.$emit('click', btn)}}},[_vm._t("default",function(){return [_vm._v("\n        "+_vm._s(btn.text)+"\n      ")]},null,btn)],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }